import makeSlice from '@web/slices/moneyToken/sliceMaker'

const slice = makeSlice()

export default slice.reducer
